export function fetchWithTimeout(
  uri: RequestInfo | URL,
  time: number,
  options: RequestInit = {}
): Promise<Response> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('[GraphQL] Request timed out.'));
    }, time);
    fetch(uri, options).then(
      (response) => {
        clearTimeout(timer);
        resolve(response);
      },
      (err) => {
        clearTimeout(timer);
        reject(err instanceof Error ? err : new Error(String(err)));
      }
    );
  });
}
